"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnumValue = void 0;
function isEnumValue(value) {
    return typeof value !== 'string';
}
exports.isEnumValue = isEnumValue;
